"use client";

import { useSyncExternalStore } from "react";
import {
  type CookieConsent,
  getCookieConsentServerSnapshot,
  getCookieConsentSnapshot,
  subscribeCookieConsent,
} from "@/lib/cookie-consent";

export function useCookieConsent(): CookieConsent {
  return useSyncExternalStore(subscribeCookieConsent, getCookieConsentSnapshot, getCookieConsentServerSnapshot);
}
